//  For pages that need to update navigation bar:
//  - Update title to reflect content shown no page
//  - Add Save button, Done button, etc
//
//    <Navbar title="Page title">
//      <Navbar.RightButton label="Save" onClick={save}/>
//    </Navbar>
//
//  Properties:
//
//  title    - Title (optional)
//  backLink - Use this URL for the back button
//
//  You can replace the left and right buttons by adding Navbar.LeftButton or
//  Navbar.RightButton children.
//
//  If you do not add a left button, the navbar will include a back link:
//  - Use the URL of the backLink property is specified
//  - Otherwise, the parent URL or the current page URL
//  - Back button to secondary page is always visible
//  - Back button to primary page only visible on mobile

import './navbar.less';

import { Navbar as F7Navbar, Link } from 'framework7-react';
import { NavTitle as F7NavTitle }   from 'framework7-react';
import { SplitViewContext }         from './split_view';
import React                        from 'react';

export default class Navbar extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      backURL:     '/',
      useBackLink: false
    };

    this.checkBackLink   = this.checkBackLink.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentDidMount() {
    this.$f7ready(f7 => {
      const { url } = f7.views.main.router.currentRoute;
      const route   = url && f7.views.main.router.findMatchingRoute(url);
      if (route)
        this.checkBackLink(f7, route);
      f7.views.main.router.once('routeChange', this.checkBackLink.bind(null, f7));
    });
  }

  checkBackLink(app, route) {
    const parts       = route.url.split('/');
    const useBackLink = parts.length > 3;
    const backURL     = route.url.split('/').slice(0, -1).join('/');

    this.setState({ useBackLink, backURL });
  }

  handleBackClick() {
    const app         = this.$f7;
    const { backURL } = this.state;

    app.methods.navigateBackTo({ app, path: backURL });
  }

  render() {
    const { title }       = this.props;
    const { subtitle }    = this.props;
    const { className }   = this.props;
    const { children }    = this.props;
    const { backURL }     = this.state;
    const { useBackLink } = this.state;

    return (
      <SplitViewContext.Consumer>
        {
          isSplitView => {
            const isMobile     = !isSplitView;
            const showBackLink = isMobile || useBackLink;
            const leftButton   = getLeftButton({ backURL, children, showBackLink, onBackClick: this.handleBackClick });

            return (
              <F7Navbar sliding innerClassName={className}>
                {leftButton}
                <F7NavTitle>
                  {title}
                  {subtitle && (<Navbar.Subtitle subtitle={subtitle}/>)}
                </F7NavTitle>
                {getRightButton(children)}
              </F7Navbar>
            );
          }
        }
      </SplitViewContext.Consumer>
    );
  }
}


function getLeftButton({ children, onBackClick, showBackLink }) {
  let leftButton = null;
  React.Children.forEach(children, function(child) {
    if (child && (child.type === Navbar.LeftButton))
      leftButton = child;
  });

  if (leftButton)
    return leftButton;
  else if (showBackLink) {
    return (
      <div className="left">
        <Link onClick={onBackClick}>
          <i className="icon icon-back"></i> Back
        </Link>
      </div>
    );
  } else
    return null;
}

function getRightButton(children) {
  let rightButton = null;
  React.Children.forEach(children, function(child) {
    if (child && (child.type === Navbar.RightButton || child.type === Navbar.SaveButton))
      rightButton = child;
  });
  return rightButton;
}


Navbar.LeftButton = function LeftButton({ label, onClick }) {
  return (
    <div className="left">
      <a className="link">
        <span onClick={onClick}>{label}</span>
      </a>
    </div>
  );
};


Navbar.Subtitle = function Subtitle({ subtitle }) {
  return (
    <span className="subtitle">{subtitle}</span>
  );
};


Navbar.RightButton = function RightButton({ children, label, href, onClick, className }) {
  return (
    <div className="right">
      {children || <Link href={href} onClick={onClick} className={className}>{label}</Link>}
    </div>
  );
};


Navbar.SaveButton = function SaveButton({ label, form }) {
  return (
    <div className="right">
      <button form={form} className="save-button">{label}</button>
    </div>
  );
};
